var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('Hero'),_c('Works'),_c('Features'),_c('Mobile'),_c('Testimonials'),_c('Appraisal'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }